import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createJustText } from '@vfde-brix/just-text';

export const mountJustText = (id: string) => {
    const containerEl = document.getElementById(id);

    return containerEl && createJustText(containerEl, NO_PATTERN_BUSINESS_LOGIC);
};
